import { render, staticRenderFns } from "./updated.vue?vue&type=template&id=95ad6276"
import script from "./updated.vue?vue&type=script&lang=js"
export * from "./updated.vue?vue&type=script&lang=js"
import style0 from "./updated.vue?vue&type=style&index=0&id=95ad6276&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports